
document.addEventListener("DOMContentLoaded", ()=>{
    const buttonsCart = document.querySelectorAll('.button-cart'),
        popupRelocation=document.querySelector('#popupRelocation'),
        storePreferencesSelect = document.querySelector('#storePreferencesSelect'),
        storePreferencesOptions=storePreferencesSelect.querySelectorAll('option')
        storeIsoCode = document.querySelectorAll('[data-iso-code]'),
        storePreferencesPopup = document.querySelector('#storePreferences'),
        errorLocation = document.querySelector('.error-location'),
        confirmLocation = document.querySelector('.confirm-location'),
        productVariants = document.querySelectorAll('.sizes__inner .size-option'),
        storePreferencesSelectOptions = Array.from(document.querySelectorAll('#storePreferencesSelect option')).map(option => option.value),
        storePreferencesClose=document.querySelector('#storePreferences--confirm'),
        relocPopupClose=document.getElementById('reloc_popup__close');
       
        
        //reloc update
        if(relocPopupClose!=null){
            relocPopupClose.addEventListener('click',()=>{
                storePreferences.classList.add('active')
            })
        }
    async function geoIpResponse () {
        const getApi = await fetch('/browsing_context_suggestions.json')
        const apiData = await getApi.json()
        getCountryCode(apiData.detected_values.country.handle, apiData.detected_values.country.name);
        //first visited 
        getVisitStatus(apiData.detected_values.visited)
    };
  
    function getVisitStatus(visited){
       if(getCookie('visited')){
            return
        }
       else if(storePreferencesSelect){
           
            storePreferencesPopup.classList.remove("active")
            if(popupRelocation){
                 const regionForRedirect = filterProductData(getCookie('country'));
                 let store=getCookie('country-name')
                 let continueBtn=popupRelocation.querySelector('#continueToStore').children[0]
                 if(regionForRedirect && regionForRedirect.length>0){
                    //let store=getCookie('country-name')
                    popupRelocation.querySelector('.popup__title').innerHTML=popupRelocation.querySelector('.popup__title').innerHTML.replace('[country]', store)
                    popupRelocation.querySelector('.popup__subtitle').innerHTML=popupRelocation.querySelector('.popup__subtitle').innerHTML.replace('[store]', regionForRedirect[0].region)
                    //let continueBtn=popupRelocation.querySelector('#continueToStore').children[0]
                    if(continueBtn.children[0]==undefined){
                        continueBtn.innerHTML=continueBtn.innerHTML.replace('[store]', regionForRedirect[0].region)
                    }
                    else{
                        continueBtn.children[0].innerHTML=continueBtn.children[0].innerHTML.replace('[store]', regionForRedirect[0].region)
                    }
                 }else{
                     //ISO code missing in settings
                     popupRelocation.querySelector('.popup__title').innerHTML=regionCountries[0].message
                     popupRelocation.querySelector('.popup__subtitle').innerHTML=popupRelocation.querySelector('.popup__subtitle').innerHTML.replace('[store]', regionCountries[0].region)
                     if(continueBtn.children[0]==undefined){
                        continueBtn.innerHTML=continueBtn.innerHTML.replace('[store]', regionCountries[0].region)
                        //console.log(continueBtn.closest('.btn'))
                        continueBtn.setAttribute('href',regionCountries[0].shop_link)
                    }
                    else{
                        continueBtn.children[0].innerHTML=continueBtn.children[0].innerHTML.replace('[store]', regionCountries[0].region)
                        //console.log(continueBtn.closest('.btn'))
                        continueBtn.closest('.btn').setAttribute('href',regionCountries[0].shop_link)
                    }
                 }
            }
    
            popupRelocation.classList.add("active")
            document.querySelector('body').classList.add('hidden-body')
            document.cookie="visited=true"
        }else return
    }
    function getCountryCode (isoCOde, countryName) {
            if(getCookie('country') && getCookie('country-name')){
                getProductData(getCookie('country'), getCookie('country-name'));
                storeIsoCode.forEach(code => {
                    code.textContent = getCookie('country-name');
                });
                // storeIsoCode.textContent = getCookie('country-name');
                
            }else{
                setCookie(isoCOde, countryName);
                getProductData(isoCOde, countryName);
                storePreferencesPopup.classList.add('active');
              
                document.querySelector('body').classList.add('hidden-body')
                storeIsoCode.forEach(code => {
                    code.textContent = countryName;
                });
                // storeIsoCode.textContent = countryName;
    
            }
    }
    function setCookie(isoCode, countryName){
        document.cookie = `${encodeURIComponent('country')}=${encodeURIComponent(isoCode)}; path=/;`;
        document.cookie = `${encodeURIComponent('country-name')}=${encodeURIComponent(countryName)}; path=/;`;
        storePreferencesPopup.classList.remove('active')
        
        document.querySelector('body').classList.remove('hidden-body')
    }
    function getCookie(name) {
        let matches = document.cookie.match(new RegExp(
          "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }
    async function getProductData(isoCode, countryName){
        let optionSelected = ''; 
        if(window.location.pathname.includes('/products/')){
            const handle = window.location.pathname.split('/products/')[1];
            const data = await fetch(`/products/${handle}/?view=inventory`);
            const productData = await data.json();
            storePreferencesSelect.value = storePreferencesSelectOptions.find(code => code === isoCode) ? isoCode : '';
            storePreferencesSelect.addEventListener('change', () => {
                optionSelected = Array.from(storePreferencesSelect.options).filter(option => option.selected === true)[0].textContent;
                checkIsoCode(productData, storePreferencesSelect.value, optionSelected)
            });
            checkIsoCode(productData, isoCode, countryName);
        }else{
            storePreferencesSelect.value = storePreferencesSelectOptions.find(code => code === isoCode) ? isoCode : '';
            storePreferencesSelect.addEventListener('change', () => {
                optionSelected = Array.from(storePreferencesSelect.options).filter(option => option.selected === true)[0].textContent;
                checkIsoCode({inventory: {}}, storePreferencesSelect.value, optionSelected);
            });
            checkIsoCode({inventory: {}}, isoCode, countryName);
        }
    }
    
    function filterProductData(isoCode){
        return regionCountries.filter(info => info.countries.some(code => code === isoCode) ? info.region : null);
    }
    function checkIsoCode(productData, isoCode, optionSelected){
        const region = filterProductData(isoCode);
        
        storeIsoCode.forEach(code => {
            code.textContent = optionSelected;
          
        });
        // storeIsoCode.textContent = optionSelected;

        if(region && region.length > 0){
            errorLocation.classList.remove('show')
            
        }else{
            errorLocation.classList.add('show')
            
        }
        confirmLocation.addEventListener('click', () => setCookie(isoCode, optionSelected))
        
        if(window.location.pathname.includes('/products/')){
            const inventory = productData.variantsInventory.map(inventory => {
                return {id:inventory.id, inventory: Object.keys(inventory.inventory)}
            });
           
            if(region && region.length > 0){
                const filterInventory = inventory.filter(variant => {
                    if(variant.inventory.some(code => code === region[0].region)){
                        return variant.id
                    }
                })

				productVariants.forEach(variant => {
                    variant.classList.remove('disabled')
                    variant.classList.remove('size-option--active')
                    filterInventory.forEach(item => {
                        if(+variant.dataset.variantId === item.id){                    
                            variant.classList.add('disabled')
                        }
                    })
           
                    
                })
                buttonsCart.forEach(button => {
                    if (productVariants.length > 0) {
                        button.querySelector('.btn__name').textContent = button.querySelector('.btn__name').dataset.selectSize
                    } else {
                      
                      var singleVariant = parseInt(document.querySelectorAll('[name=id] option')[0].value)
                      if(filterInventory[0] && singleVariant === filterInventory[0].id){                    
                        button.classList.add('disabled')
                        button.querySelector('.btn__name').textContent = button.querySelector('.btn__name').dataset.soldOut
                      }
                      else {
                        button.classList.remove('disabled')
                        button.querySelector('.btn__name').textContent = button.querySelector('.btn__name').dataset.addToCart
                      }
                    }
                })
            }else{
                productVariants.forEach(variant => {
                    variant.classList.remove('size-option--active')
                    variant.classList.add('disabled')
                })
                buttonsCart.forEach(button => {
                    button.classList.add('disabled')
                    button.querySelector('.btn__name').textContent = button.querySelector('.btn__name').dataset.soldOut
                })
            }
            if (!inventory.some( item => item.inventory.length > 0 )) {
                productVariants.forEach(variant => {
                    variant.classList.remove('disabled')
                })
            }
        }
        
    }
    geoIpResponse()
    function filterIsoForRedirect(isoCode){
        return regionCountries.filter(info => info.countries.some(code => code === isoCode) ? info.region : null);
    }
    let currentCountry=getCookie('country')
    let currentRegion=filterIsoForRedirect(currentCountry)
    if(currentRegion && currentRegion.length > 0){
        currentRegion=currentRegion[0].region
    }
    else currentRegion=null
    //console.log(currentRegion)
    function redirect(){
        //storePreferencesPopup.addEventListener('change',()=>{
            console.log("currentRegion")
            console.log(currentRegion)
           
            const region = filterIsoForRedirect(storePreferencesSelect.value);
            optionSelected = Array.from(storePreferencesSelect.options).filter(option => option.selected === true)[0].textContent;
            console.log("region")
            console.log(region)
            if(region && region.length > 0){
                if(region[0].region == currentRegion){
                    setCookie(storePreferencesSelect.value, optionSelected)
                    //console.log("cookie updated")
                }
                else{
                    currentRegion=region[0].region
                    console.log('should be redirect')
                    document.location.href = region[0].shop_link
                }
            }
        //})

    }
    storePreferencesClose.addEventListener('click',()=>{
        document.cookie="countryListShowed=true"
        redirect()
    })


    function checkDeliveryCountry(){
        console.log('update: ')
        let countryListShowed=getCookie('countryListShowed')
        let countryStatus=false
//console.log(regionCountries)
//console.log('countryListShowed: '+countryListShowed)
        if(countryListShowed === undefined && getCookie("visited") != undefined &&countryStatus===false){
            storePreferencesPopup.classList.add('active');
            document.querySelector('body').classList.add('hidden-body')
        }
        console.log(currentCountry)
        
        regionCountries.forEach(element => {
            for(let i=0;i<element.countries.length;i++){
                if(element.countries[i]==currentCountry){
                    countryStatus=true
                }
            }
        });
        if(getCookie('countryListShowed')!== undefined && countryStatus===false){
            document.querySelector('body').classList.add('hidden-body')
            //console.log(regionCountries[0].countries[0])
            
            storePreferencesSelect.value = storePreferencesSelectOptions.find(code => code === regionCountries[0].countries[0]) ? regionCountries[0].countries[0] : '';
            optionSelected = Array.from(storePreferencesSelect.options).filter(option => option.selected === true)[0].textContent;
            console.log(optionSelected)
            setCookie(storePreferencesSelect.value, optionSelected)
            //  console.log("cookie updated")
            storePreferencesPopup.classList.add('active');
        }
    }
    checkDeliveryCountry()
    //console.log(popupRelocation.querySelector('.popup-layout-bg'))
    popupRelocation.querySelector('.popup-layout-bg').addEventListener('click',()=>{
        storePreferencesPopup.classList.add('active');
        document.querySelector('body').classList.add('hidden-body')
        
    })
    storePreferencesPopup.querySelector('.popup-layout-bg').addEventListener('click',()=>{
        document.cookie="countryListShowed=true"
    })

    function setDeliveryCountry(){

    }
});



